module.exports = __webpack_public_path__ + "img/band.c9c4de06.png";